import React, { useEffect } from "react";
import NavModuleSearchTag from "./NavModuleSearchTag";
import { chunk } from "../../../../../lib/helpers";
import { useStore } from "../../../../../lib/context";
import { observer } from "mobx-react-lite";


const NavModuleSearchTags = observer(() => {
    const {articleQueryStore: {activeTagPage}, uiStore:{isMobile}} = useStore();


    const chunkedTags = chunk(activeTagPage, isMobile ? 2 : 3);
    return (
        <div className="nav-module-search-tags">
            {chunkedTags.map((chunk, idx) => {
                return (
                    <div className="flex tag-group" key={`nm-stchunk-${idx}`}>
                        {chunk.map((tag) => {
                            return (
                                <NavModuleSearchTag key={`nmi-${tag.name}`}>
                                    {tag.name}
                                </NavModuleSearchTag>
                            )
                        })}
                    </div>
                )
            })}

            {/* {tags.map((item) => {
                return (
                    <NavModuleSearchTag key={`nmi-${item.name}`}>
                        {item.name}
                    </NavModuleSearchTag>
                )
            })} */}



            <style jsx>{`
                .nav-module-search-tags {
                    width: 400px;
                    margin: 0 auto;
                    padding: 14px 0;
                    padding-top: 0;
                }

                .tag-group {
                    justify-content: center;
                }

                .nav-module-search-tags :global(.nav-module-search-tag) {
                    margin: 6px 6px;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .nav-module-search-tags {
                        width: 300px;
                    }
                
                }
            `}</style>
        </div>
    )
});

export default NavModuleSearchTags